module.exports = __webpack_public_path__ + "img/google.84cc01dc.png";